var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, Typography } from "@mui/material";
export var UnderwriteComponent = function (_a) {
    var status = _a.status, TextData = _a.TextData, date = _a.date;
    return (_jsx(Box, __assign({ hidden: status }, { children: _jsxs(Grid, __assign({ container: true }, { children: [_jsx(Grid, __assign({ item: true, xs: 10 }, { children: _jsx(Typography, __assign({ style: { wordWrap: "break-word" }, variant: 'caption' }, { children: TextData })) })), _jsx(Grid, __assign({ item: true, xs: 10 }, { children: _jsx(Typography, __assign({ style: { wordWrap: "break-word" }, variant: 'caption' }, { children: date })) }))] })) })));
};
